<template>
  <div>
    <content-frame
          :frame-src="frameSrc"
          :change="true"
    />
    <v-text-field v-if="frameSrcId"
              v-model="frameSrc"
              label="Ссылка на карту (iframe src)"
              required
              outlined
    />
    <v-btn @click="saveChanges">Сохранить изменения</v-btn>
  </div>
</template>

<script>
import ContentFrame from "@/components/ui/ContentFrame.vue";
export default {
  name: "ChangeContentFrame",
  components: { ContentFrame },
  data () {
    let content_to_change = this.$store.getters['contentChanges/content_to_change']
    return {
      'frameSrc': content_to_change['frameSrc']['value_rus']
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale
    },
    frameSrcId() {
      return this.$store.getters['contentChanges/content_to_change']['frameSrc']['id_content']
    }
  },
  methods: {
    /**
     * Конвертирует ссылку из конструктора карт Яндекса в URL для виджета (iframe).
     * Из: https://yandex.ru/maps/?um=constructor%3A<id>&source=constructorLink
     * В:  https://yandex.ru/map-widget/v1/?um=constructor%3A<id>&source=constructor
     */
    toYandexMapWidgetUrl (input) {
      if (!input || typeof input !== 'string') return input
      const trimmed = input.trim()
      const isConstructorPage = /yandex\.ru\/maps\//i.test(trimmed) && /source=constructorLink/i.test(trimmed)
      const umMatch = trimmed.match(/um=constructor%3A([^&\s]+)/i)
      if (isConstructorPage && umMatch) {
        const constructorId = umMatch[1]
        return `https://yandex.ru/map-widget/v1/?um=constructor%3A${constructorId}&source=constructor`
      }
      return trimmed
    },
    saveChanges () {
      let valueList = []
      if (this.frameSrcId) {
        const rawUrl = this.frameSrc === undefined ? '' : this.frameSrc
        const url = this.toYandexMapWidgetUrl(rawUrl)
        valueList.push({
          value_rus: url,
          value_eng: url,
          id_content: this.frameSrcId
        })
      }
      this.$store.dispatch('contentChanges/SAVE_CONTENT_CHANGES', {
        valueList: valueList
      })
    }
  }
}
</script>

<style scoped>

</style>
